import { applyMiddleware, compose, createStore, GenericStoreEnhancer } from "redux";
import rootReducer from "./reducers";

// Let TypeScript know about the Redux Dev Tools
declare var __REDUX_DEVTOOLS_EXTENSION__: () => void;
let devToolsExtension: GenericStoreEnhancer;
try {
    devToolsExtension = __REDUX_DEVTOOLS_EXTENSION__ ? __REDUX_DEVTOOLS_EXTENSION__() : (f: any) => f;

} catch (err) {
    devToolsExtension = (f: any) => f;
}

const initialState = {};
const middleWare = [];

const irmsStore = createStore(
    rootReducer,
    initialState,
    compose(
        applyMiddleware(...middleWare),
        devToolsExtension
    ) as GenericStoreEnhancer
);

export default irmsStore;
